


/**
 * @classdesc Vague d'une course
 * @kind class
 * @export
 * @prop {int} id - id de la vague
 * @prop {int} id_course - Id de la course
 * @prop {boolean} justificatif - Justificatif obligatoire pour cette vague
 * @prop {boolean} masque_inscrits - Masquer cette vague aux inscrits
 * @prop {string} nom - Nom de la vague
 * @prop {int} nb_inscrits - Nombre d'inscrits à cette vague
 * @prop {int} nombre - Nombre de place total de cette vague
 * @prop {int} places_restantes - Nombre de places restantes à cette vague
 * @prop {boolean} selected - Vague sélectionnée
 * 
 * 
 * @class Vague_Course
 */
export class Vague_Course {
    id;
    id_course;
    justificatif;
    masque_inscrits;
    nom;
    nb_inscrits;
    nombre;
    places_restantes;
    selected = false;
    metadatas;

    /**
     * Creates an instance of Vague_Course.
     * @constructs
     * @kind function
     * @memberof Vague_Course
     */
    constructor() { }

    set(data) {

        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }

    is_available(vip_ins, list_courses = null) {
        if (vip_ins && vip_ins.limit_acces_parcours == "0") return true;
        if (vip_ins && vip_ins.limit_acces_parcours == "1") { // Si le VIP a accès à certains parcours
            for (let j = 0; j < vip_ins.filter_parcours.length; j++) {
                if (vip_ins.filter_parcours[j].id == this.id_course) { // Si le parcours est dans la liste des parcours autorisé du VIP
                    return true;
                }
            }
        }
        return this.get_places_restantes(list_courses) > 0;
    }

    get_places_restantes(list_courses) {
        let limitation_groupe_vague = this.get_metadata_by_name("groupe_max_vague");
        if (limitation_groupe_vague) {
            let current_groupe_vague = limitation_groupe_vague.valeur;
            let nb_inscrits_in_groupe = this.get_inscrits_in_group(list_courses, current_groupe_vague);
            let restantes = parseInt(this.nombre) - nb_inscrits_in_groupe;
            return Math.max(restantes, 0);
        }

        let restantes = parseInt(this.nombre) - parseInt(this.nb_inscrits);
        return Math.max(restantes, 0);
    }

    get_inscrits_in_group(list_courses, groupe_max_vague) {
        let nb_inscrits = 0;
        if (!list_courses || !list_courses.list) {
            return 0;
        }

        for (let i = 0; i < list_courses.list.length; i++) {
            let course = list_courses.list[i];
            if (!course.vagues || !course.vagues.list) continue;
            for (let j = 0; j < course.vagues.list.length; j++) {
                let vague = course.vagues.list[j];
                let vague_groupe = vague.get_metadata_by_name("groupe_max_vague");
                if (vague_groupe && vague_groupe.valeur == groupe_max_vague) {
                    nb_inscrits += parseInt(vague.nb_inscrits);
                }
            }
        }
        return nb_inscrits;
    }

    get_metadata_by_name(name) {
        if (!this.metadatas) return null;
        return this.metadatas.find(metadata => metadata.nom == name);
    }







}